export const apiResources = {

    // Version properties
    v1: '/v1',

    // Navigation
    navigation: {
        base: '/navigation',
        menu: '/menu',
    },

    // Notificações in-app (sino + tela dedicada /notifications)
    // GET  /v1/notifications?page&category&type&read → LengthAwarePaginator (per_page é constante no repository — não enviar)
    // GET  /v1/notifications/unread-count → { count }
    // PUT  /v1/notifications/{id}/read | /v1/notifications/read-all → { success }
    notifications: {
        base: '/notifications',
        unreadCount: '/unread-count',
        read: '/read',
        readAll: '/read-all',
    },

    //Path Resources
    financial: {
        base: '/financial',
        entry: {
            base: '/entries',
            getEntriesByMonthlyRange: '',
            getAmountByEntryType: '/getAmountByEntryType',
            getEntriesType: '/getEntriesType',
            getNoCompensateAmount: '/getNoCompensateAmount',
            getConsolidationEntriesByStatus: '/getConsolidationEntriesByStatus',
            getEntriesByTransactionCompensation: '/getEntriesByTransactionCompensation',
            updateStatusConsolidationEntries: '/updateStatusConsolidationEntries',
            getDevolutionEntries: '/getDevolutionEntries',
            uploadReceiptEntry: '/uploadReceiptEntry',
            files: {
                base: '/files',
                type: {
                    assets: '/assets',
                    receipt: '/uploadReceiptEntry'
                }
            },
            indicators: {
                base: '/indicators',
                getEntriesIndicators: '/getEntriesIndicators',
            },
        },
        receipts: {
          base: '/receipts',
          overview: '/overview',
          /**
           * Envio em LOTE de comprovantes (multipart form-data) — aba
           * "Processamento em Lote" (/financial/receipts/batch).
           * POST /v1/financial/receipts/batch-upload
           *   fields: files[] (1..20) + metadados do lote (tenant, module,
           *   docType, docSubType, divisionId, groupId, accountId, isPayment,
           *   isDevolution, isGroupDevolution, isRegistrationPayment,
           *   isCreditCardPurchase, status, path, creditCardPayment,
           *   transferPayment) — SEM amount.
           * Response: 201 (processed > 0) | 200 (nada processado);
           *   body { message, success, processed, failed,
           *   items: [{ index, fileName, status: 'ok'|'error', error?,
           *   syncStorageId? }] }
           */
          batchUpload: '/batch-upload',
          /**
           * Status de processamento dos sync_storage enviados por lote
           * (polling da aba "Processamento em Lote").
           * GET /v1/financial/receipts/batch-upload/status?ids={ids vírgula}
           *   mesma auth/gate `rct-batch` do batch-upload; ids inexistentes
           *   são omitidos.
           * Response: { success: true, data: [
           *   { id, status, processed: bool (terminal de sucesso),
           *     finished: bool (terminal qualquer) } ] }
           */
          batchUploadStatus: '/batch-upload/status',
          /**
           * Histórico PERSISTIDO dos lotes (cards do bloco "Status de
           * processamento" da aba batch — PONTO 3 2026-09-01).
           * GET /v1/financial/receipts/batch-upload/batches?limit=50
           *   (default 50, clamp 1..100) — mais recentes primeiro.
           * Response FLAT: { batches: [{ id, user: {id,name}, doc_sub_type,
           *   division_id, group_id, account_id, total_files,
           *   counts: { to_process, processing, done, duplicated, error,
           *     download_error, upload_error, invalid_recipient,
           *     closed_month, upload_failed }, created_at }], total }
           * Agregados DERIVADOS ao vivo do status da sync_storage;
           * upload_failed = itens que falharam no upload (sem linha na
           * sync_storage). Mesmo gate rct-batch da aba.
           */
          batchBatches: '/batch-upload/batches',
          notProcessed: {
            base: '/not-processed',
            getReceiptsProcessing: '/getReceiptsProcessing',
            deleteReceiptsProcessing: '/deleteReceiptsProcessing',
            /**
             * Reprocessa um registro de sync_storage (erros técnicos do
             * pipeline de download/upload). Recebe o ID de sync_storage.
             * Endpoint: POST /v1/financial/receipts/not-processed/reprocess/{id}
             */
            reprocess: '/reprocess',
            /**
             * Reprocessa um registro de receipt_processing (dados parciais
             * que precisam revisão OU reprocessamento LLM/OCR). Recebe o ID
             * de receipt_processing — o mesmo ID listado pelo endpoint
             * getReceiptsProcessing e exibido na tela unificada.
             * Endpoint: POST /v1/financial/receipts/not-processed/reprocess-receipt-processing/{id}
             */
            reprocessReceiptProcessing: '/reprocess-receipt-processing',
            /**
             * Reprocessa TODOS os comprovantes com erro de uma vez, operando
             * sobre sync_storage filtrado por docType.
             * Endpoint: POST /v1/financial/receipts/not-processed/reprocess-all
             */
            reprocessAll: '/reprocess-all',
            /**
             * Últimos comprovantes concluídos (status='done') — usado no bloco
             * "Últimos processamentos" > tab "Concluídos".
             * Endpoint: GET /v1/financial/receipts/not-processed/last-completed?docType=entries&limit=5
             */
            lastCompleted: '/last-completed',
          },

          duplicitiesAnalysis: {
            base: '/duplicities-analysis',
            // Entries side (centralized route: /financial/receipts/duplicities-analysis/entries)
            getDuplicitiesEntries: '/entries',
            getReceiptsByEntriesIds: '/by-entries-ids',
            saveDuplicityAnalysis: '/entries/save',
            // Exits side (centralized route: /financial/receipts/duplicities-analysis/exits)
            getDuplicitiesExits: '/exits',
            getReceiptsByExitsIds: '/by-exits-ids',
            saveDuplicityAnalysisExits: '/exits/save',
          },

          processed: {
            base: '/processed',
            summary: '/processed-summary',
          },

        },
        automation: {
            base: '/automation',
            getReadingErrorReceipts: '/getReadingErrorReceipts',
            deleteReadingErrorReceipt: '/deleteReadingErrorReceipt',
        },
        consolidations: {
            base: '/consolidation',
            getMonths: '/getMonths',
            months: '/months',
            getTotalAmountEntries: '/getTotalAmountEntries',
            consolidateMonth: '/consolidateMonth',
            reopenConsolidatedMonth: '/reopenConsolidatedMonth',
        },
        cults: {
            base: '/cults',
            createCult: '/createCult',
            updateCult: '/updateCult',
            getCults: '/getCults',
            getCultById: '/getCultById',
            /**
             * Comprovantes de culto compartilhados pelo app Sharing aguardando
             * apontamento (vínculo a um culto).
             * GET /financial/entries/cults/getPendingCultReceipts
             * Query opcional: dates=YYYY-MM,YYYY-MM (LIKE sobre a data do depósito).
             */
            getPendingCultReceipts: '/getPendingCultReceipts',
            /**
             * Base do descarte (soft) de comprovante pendente.
             * DELETE /financial/entries/cults/pendingReceipts/{id}
             */
            pendingReceipts: '/pendingReceipts',
        },
        reports: {
            base: '/reports',
            entries: {
                base: '/entries',
                generateMonthlyReceiptsReport: '/generateMonthlyReceiptsReport',
                generateMonthlyEntriesReport: '/generateMonthlyEntriesReport',
                getReports: '/getReports',
                /**
                 * Exclui relatórios de entradas em lote.
                 * Endpoint: POST /v1/financial/reports/entries/deleteReports
                 * Body: { ids: number[] } → 200 { message }
                 */
                deleteReports: '/deleteReports',
            },
            exits: {
                base: '/exits',
                generateMonthlyReceiptsReport: '/generateMonthlyReceiptsReport',
                generateMonthlyExitsReport: '/generateMonthlyExitsReport',
                getReports: '/getReports',
                /**
                 * Exclui relatórios de saídas em lote.
                 * Endpoint: POST /v1/financial/reports/exits/deleteReports
                 * Body: { ids: number[] } → 200 { message }
                 */
                deleteReports: '/deleteReports',
            },
            balances: {
                base: '/balances',
                generateMonthlyBalancesReport: '/generateMonthlyBalancesReport',
                getReports: '/getReports',
                /**
                 * Exclui relatórios de saldos em lote.
                 * Endpoint: POST /v1/financial/reports/balances/deleteReports
                 * Body: { ids: number[] } → 200 { message }
                 */
                deleteReports: '/deleteReports',
            },
            purchases: {
                base: '/purchases',
                generateMonthlyReceiptsReport: '/generateMonthlyReceiptsReport',
                generateMonthlyPurchasesReport: '/generateMonthlyPurchasesReport',
                getReports: '/getReports',
                /**
                 * Exclui relatórios de compras em lote.
                 * Endpoint: POST /v1/financial/reports/purchases/deleteReports
                 * Body: { ids: number[] } → 200 { message }
                 */
                deleteReports: '/deleteReports',
            },
            summary: {
                base: '/summary',
                generateMonthlySummaryReport: '/generateMonthlySummaryReport',
                generateFinancialSlideReport: '/generateFinancialSlideReport',
                generateConsolidatedReport: '/generateConsolidatedReport',
                getReports: '/getReports',
                /**
                 * Exclui relatórios em lote.
                 * Endpoint: POST /v1/financial/reports/summary/deleteReports
                 * Body: { ids: number[] } → 200 { message }
                 */
                deleteReports: '/deleteReports',
            },
        },
        reviewers: {
            base: '/reviewers',
            getFinancialReviewers: '/getFinancialReviewers',
        },
        settings: {
            base: '/settings',
        },
        exits: {
            base: '/exits',
            payments: {
                base: '/payments',
                categories: '/categories',
                items: '/items',
            },
            indicators: {
                base: '/indicators',
                getAmountByExitType: '/getAmountByExitType',
                getExitsAmount: '/getExitsAmount',
            },
                purchases: {
                    base: '/purchases',
                    postpone: '/postpone',
                    invoices: {
                        base: '/invoices',
                        getInvoices: '/getInvoices',
                        getInvoiceIndicators: '/getInvoiceIndicators',
                        payments: {
                            base: '/payments',
                            getInvoicePayments: '',
                            deleteInvoicePayment: '',
                        }
                    }
                },
            installments: {
                base: '/installments',
                getInstallments: '/getInstallments',
                getInstallmentsByPurchase: '/getInstallmentsByPurchase',
            },
            reports: {
                base: '/reports',
                generateMonthlyReceiptsReport: '/generateMonthlyReceiptsReport',
                generateMonthlyExitsReport: '/generateMonthlyExitsReport',
                getReports: '/getReports',
            },
            receipts: {
                base: '/receipts',
                duplicitiesAnalysis: {
                    base: '/duplicities-analysis',
                    getDuplicitiesExits: '/getDuplicitiesExits',
                    getReceiptsByExitsIds: '/getReceiptsByExitsIds',
                    saveDuplicityAnalysis: '/saveDuplicityAnalysis',
                },
            },

        },
        movements: {
            base: '/movements',
            getMovementsByGroup: '/getMovementsByGroup',
            getIndicatorsByGroup: '/getIndicatorsByGroup',
            addInitialBalance: '/addInitialBalance',
            resetBalance: '/resetBalance',
        },
        accountsCards: {
            base: '/accounts-cards',
            cards: {
                base: '/cards',
                getCards: '/getCards',
                getCardById: '/getCardById',
                deactivateCard: '/deactivateCard',
                deleteCard: '',
                saveCard: '/saveCard',
            },
            accounts: {
                base: '/accounts',
                saveAccount: '/saveAccount',
                getAccounts: '/getAccounts',
                getAccountsIndicators: '/getAccountsIndicators',
                getMonthSummary: '/getMonthSummary',
                getConciliationStatus: '/getConciliationStatus',
                deactivateAccount: '/deactivateAccount',
                files: {
                    base: '/files',
                    saveFile: '/saveFile',
                    processFile: '/processFile',
                    getAccountsFiles: '/getAccountsFiles',
                    getPendingFiles: '/getPendingFiles',
                    deleteFile: '/deleteFile',
                },
                movements: {
                    base: '/movements',
                    getMovements: '/getMovements',
                    getRecentMovements: '/getRecentMovements',
                    /**
                     * Re-concilia movimentos bancários contra lançamentos do sistema.
                     * Body (modo 1): { movementIds: number[] }
                     * Body (modo 2): { accountId: number, yearMonth: 'YYYY-MM' }
                     * Response: { data: { reconciled: number[], notFound: number[], totalProcessed: number } }
                     */
                    reconcile: '/reconcile',
                }
            }
        },
        balances: {
            base: '/balances',
            reports: {
                base: '/reports',
                generateGeneralBalancesReport: '/generateGeneralBalancesReport',
                getReports: '/getReports',
            },
        },
        accounting: {
            base: '/accounting',
            accountPlan: {
                base: '/account-plan',
                search: '/search',
            },
            bankReconciliation: {
                base: '/bank-reconciliation',
                movements: '/movements',
                fileStatus: '/file-status',
            },
        },
        /**
         * Contas a Pagar (v1) — screen_key `ctp-access`.
         * Base: GET/POST /v1/financial/accounts-payable
         * Subpaths:
         *   GET    /                    → { accountsPayable[], links {first,last,prev,next}, meta } (simplePaginate)
         *   GET    /{id}                → { account }
         *   POST   /                    → 201 { message, account }
         *   PUT    /{id}                → full replacement; 400 se conta já paga
         *   DELETE /{id}                → soft delete; 400 se conta já paga
         *   POST   /{id}/mark-as-paid   → { paymentDate, paymentMethod?, exitId? } → { message, account }
         *   DELETE /{id}/exit-link      → 200 { message, account }; 422 ACCOUNT_NOT_LINKED; 403 ACCESS_DENIED
         *   POST   /{id}/exit-link      → { exitId } → 200 { message, account } (ANEXO em conta PAGA
         *                                 standalone; conta/data/método PRESERVADOS — 2026-10-18)
         *   GET    /{id}/exit-candidates → { exits[] } (saídas não vinculadas p/ vínculo na baixa)
         *   POST   /{id}/files          → { originalFilename, link, typeDir? } → { message, file }
         *   DELETE /files/{fileId}      → 200; 400 se conta já paga
         *   GET    /indicators          → { indicators { toPay, overdue, paidThisMonth, alertsCount } }
         *   GET    /alerts              → { alerts[], total }
         *   GET    /monthly-summary     → { monthlySummary[] } (months=1..24, default 12)
         */
        accountsPayable: {
            base: '/accounts-payable',
            indicators: '/indicators',
            alerts: '/alerts',
            markAsPaid: '/mark-as-paid',
            exitCandidates: '/exit-candidates',
            /**
             * Rota da SAÍDA VINCULADA (2026-10-17/18): DELETE remove o vínculo
             * (reabre a conta); POST anexa uma saída a uma conta PAGA standalone
             * (mantém data/método de pagamento).
             */
            exitLink: '/exit-link',
            files: '/files',
            monthlySummary: '/monthly-summary',
            // v2 "Contas a pagar pelo app" (2026-09-29) — CRUD de categorias de
            // contas + fila de complementação (gate ctp-access).
            categories: '/categories',
            pendingCompletion: '/pending-completion',
        },
    },
    dashboards: {
        base: '/dashboards',
        financial: {
            entries: {
                entriesEvolution: '/getEntriesEvolution'
            }
        },
    },
    dashboard: {
        base: '/dashboard',
        overview: '/overview',
        entriesVsExits: '/entries-vs-exits',
        exitsByMonth: '/exits-by-month',
        /**
         * Uso real de armazenamento do tenant (bucket + banco de dados).
         * Endpoint: GET /v1/dashboard/storage-usage
         */
        storageUsage: '/storage-usage',
    },
    secretary: {
        base: '/secretary',
        membership: {
            base: '/membership',
            // Rotas dedicadas da Visão Geral (Overview): cada indicador é gated
            // pelo seu CARD (ex: mem-tithers-indicators), independente das tabs.
            overview: {
                base: '/overview',
                membersIndicators: '/members-indicators',
                tithers: '/tithers',
                birthdays: '/birthdays',
            },
            getMembersByType: '',
            getMembersIndicators: '/getMembersIndicators',
            batch: '/batch',
            deactivationReason: '/deactivation-reason',
            report: '/report',
            files: {
                base: '/files',
                assets: {
                    base: '/assets',
                    avatar: '/avatar'
                }
            }
        },
        birthdays: {
            base: '/birthdays',
            getMembersByBornMonth: '/getMembersByBornMonth',
            exportBirthdaysData: '/exportBirthdaysData',
        },
        tithers: {
            base: '/tithers',
            getTithersByDate: '/getTithersByDate',
            exportTithersData: '/exportTithersData',
            getTitheHistory: '/getTitheHistory',
        },
        documents: {
            base: '/documents',
            overview: '/overview',
            minutes: {
                base: '/minutes',
                indicators: '/indicators',
                uploadAudio: '/upload-audio',
                presignedUploadUrl: '/presigned-upload-url',
                confirmUploadAudio: '/confirm-upload-audio',
                audioStatus: '/audio-status',
                retryAudioTranscription: '/retry-audio-transcription',
                transcriptionQuota: '/transcription-quota',
            },
            contracts: {
                base: '/contracts',
            }
        }
    },
    users: {
        base: '/users',
        status: '/status',
        getTotalUsersByRoles: '/getTotalUsersByRoles',
        changePassword: '/change-password',
        membersLookup: '/members/lookup',
        files: {
            base: '/files',
            assets: {
                base: '/assets',
                avatar: '/avatar'
            }
        }
    },
    ecclesiastical: {
        base: '/ecclesiastical',
        divisions: {
            base: '/divisions',
            getDivisions: '/getDivisions',
            getDivisionIdByName: '/getDivisionIdByName',
            getDivisionByName: '/getDivisionByName'

        },
        groups: {
            base: '/groups',
            getGroupsByDivision: '/getGroupsByDivision',
            getGroupById: '/getGroupById',
            getAllGroups: '/getAllGroups',
            getAllGroupsWithDivisions: '/getAllGroupsWithDivisions',
            settings: {
                base: '/settings',
                ministerialInvestmentLimit: '/ministerial-investment-limit'
            },
            details: {
                base: '/details',
                movements: {
                    base: '/movements',
                    exportMovementsGroupData: '/exportMovementsGroupData',
                },
                teams: {
                    base: '/teams',
                    getMembersByGroupId: '/getMembersByGroupId',
                    addMembersToGroup: '/addMembersToGroup',
                    exportGroupTithersData: '/exportGroupTithersData'
                }
            }
        }
    },
    utils: {
        base: '/utils',
        files: {
            base: '/files',
            upload: {
                base: '/upload',
                fileUpload: '/fileUpload',
                uploadFile: '/uploadFile'
            }
        }
    },
    billing: {
        base: '/billing',
        subscription: '/subscription',
        paymentMethods: '/payment-methods',
        invoices: '/invoices',
        plans: '/plans',
        charges: '/charges'
    },
    onboarding: {
        base: '/onboarding',
        status: '/status'
    },

    // Portal do Membro — endpoints PÚBLICOS (sem autenticação Bearer; usam
    // header X-Member-Token após validação do CPF). Contexto membership
    // (URL /v1/membership/portal/*) — migrado de financial/reports/public
    // em 2026-08-18 (a API antiga foi removida no backend).
    membership: {
        base: '/membership',
        portal: {
            base: '/portal',
            validate: '/validate',
            months: '/months',
            reports: '/reports',
            /**
             * Log de rastreabilidade de acesso (fire-and-forget).
             * Endpoint: POST /v1/membership/portal/reports/access
             * Body: { reportType, reportId } → 204
             */
            reportsAccess: '/reports/access',
        },
    },

    // Portal do Membro (configurações admin — screen_key member_portal)
    memberPortal: {
        base: '/member-portal',
        settings: {
            base: '/settings',
        },
        /**
         * Meses com relatórios gerados (alimenta o seletor de meses do novo
         * link — max 24, desc).
         * GET /v1/member-portal/reports/months → {months: ['2026-07', ...]}
         */
        reports: {
            base: '/reports',
            months: '/months',
        },
        /**
         * Links de acesso expiráveis (uso único por CPF).
         * POST /v1/member-portal/links {expiresInHours?, months} → 201 (revoga os anteriores)
         * GET  /v1/member-portal/links/active → link ativo (ou campos null)
         */
        links: {
            base: '/links',
            active: '/active',
        },
    },

    // Feature configuration status (admin-only endpoints)
    features: {
        base: '/features',
        pending: '/pending',
        status: '/status',
    },

    // Trilha de Auditoria (screen_key aud-access, módulo Configurações)
    // GET  /v1/audit/logs      → { success, data[], links, meta } (LengthAwarePaginator)
    // GET  /v1/audit/logs/{id} → { success, data: { ...item + before/after/userAgent } }
    audit: {
        base: '/audit',
        logs: '/logs',
    },

    // Ajuda do sistema — chat de IA + wiki de artigos (endpoints ABERTOS, sem
    // screen_key — ver routes/tenant/help.php no backend).
    // POST  /v1/help/chat                  { message, conversationId? } → { success, data: { conversationId, answer, sourceArticle, suggestedFollowups } }
    // GET   /v1/help/articles?term&category&page&perPage              → { success, data: { items, meta, categories } }
    // GET   /v1/help/articles/{slug}                                  → { success, data: { id, title, slug, category, summary, body, sortOrder } }
    help: {
        base: '/help',
        chat: '/chat',
        articles: '/articles',
    },

    // Erros identificados + ingest (Fase 2 — Erros MVP, screen_key aud-access)
    // POST  /v1/errors/ingest            → 202 { success: true } (throttle 60/min;
    //                                       payload: exceptionClass, message, stack,
    //                                       url, userAgent, requestId, component)
    // GET   /v1/errors/identified        → { success, data[], meta } (query:
    //                                       status, per_page; 403 p/ role sem aud-access)
    // GET   /v1/errors/identified/{id}   → idem + lastEventSummary { exceptionClass,
    //                                       url, httpMethod, occurredAt }
    // GET   /v1/errors/health-summary    → { success, data: { summary { openTotal,
    //                                       bySeverity, resolvedLast30d }, downs[],
    //                                       resolutions[] } } — tela "Saúde do Sistema"
    //                                       (/health, screen_key aud-access)
    errors: {
        base: '/errors',
        ingest: '/ingest',
        identified: '/identified',
        healthSummary: '/health-summary',
    },
}
